import React from 'react';

const TermosUso = () => {
  return (
    <div className="legal-page">
      <h1><strong>Termos de Uso</strong></h1>
      
      <p>
        Ao acessar e utilizar a landing page da Soluções, você concorda em cumprir os seguintes termos e condições de uso.
      </p>

      <h2><strong>1. Natureza do Serviço</strong></h2>
      <p>
        Esta página tem finalidade <strong>estritamente informativa</strong> e de catálogo. Não oferecemos a funcionalidade de compra, reserva ou transação de produtos diretamente através deste site. Todos os preços, disponibilidade e detalhes finais devem ser confirmados em nossa loja física.
      </p>

      <h2><strong>2. Propriedade Intelectual</strong></h2>
      <p>
        Todo o conteúdo presente na landing page, incluindo textos, imagens, logotipos e design, são de propriedade exclusiva da Soluções ou de seus licenciadores, e estão protegidos por leis de direitos autorais.
      </p>

      <h2><strong>3. Uso do Conteúdo</strong></h2>
      <p>
        Você pode visualizar o conteúdo para seu uso pessoal e não comercial. A reprodução, distribuição ou modificação do conteúdo para fins comerciais sem autorização expressa é proibida.
      </p>

      <h2><strong>4. Isenção de Responsabilidade</strong></h2>
      <p>
        Embora nos esforcemos para manter as informações do site atualizadas, não garantimos a exatidão, integridade ou atualidade de todos os detalhes de produtos (cores, dimensões, etc.). A decisão final de compra deve ser baseada na inspeção do produto em nossa loja física.
      </p>

      <p className="update-date">
        Última atualização: Outubro de 2025
      </p>
    </div>
  );
};

export default TermosUso;